var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { UsuarioService } from '../../services/usuario.service';
import { PerfilService } from '../../services/perfil.service';
import { CommonService } from '../../services/common.service';
import { ServiceException } from '../../model/exception';
import { KeycloakService } from '../../services/keycloak.service';
import { AutocompleteComponent } from '../../common/autocomplete/autocomplete.component';
import { AutoCompleteConfig } from '../../common/autocomplete/autocomplete.config';
//import {MdAutocomplete} from '@md/autocomplete';
var UsuarioPopupComponent = (function () {
    function UsuarioPopupComponent(_usrService, builder, _pflService, _comService) {
        this._usrService = _usrService;
        this.builder = builder;
        this._pflService = _pflService;
        this._comService = _comService;
        this.onClose = new EventEmitter(false);
        this.EMAIL_REGEXP = "/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i";
        this.visible = false;
        this.usuario = { id: 0, codigo: "", nombre: "", apellido: "", documento: "", tipoDoc: "", perfil: "", pfl_id: 0, mail: "", activo: true, categoria: true, representante: null, activoStr: "", matricula: "", localidad: "", direccion: "", codRep: "", permisos: [], configuraciones: [] };
        this.esModoAlta = true;
        this.dataArray = [];
        this.minCharsForSearch = 3;
        this.placeholder = 'Representante'; //min amount of chars before autocomplete mayches results
        this.responseApiKey = 'codigo'; //a reference to the key for example api response [{"id":1,"name":"USA"}, {..}]
        this.responseApiText = 'nombreApellido'; //a reference to the text for example api response [{"id":1,"name":"USA"}, {..}]
    }
    UsuarioPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        //this.autocomplete.onItemSelected.subscribe((event:any) => { console.log("repre " + JSON.stringify(this.autocomplete.selectedItem)); this.repre = this.autocomplete.selectedItem });
        this.autocomplete.onItemSelected.subscribe(function (event) { _this.onChangeSelectRep(_this.autocomplete.selectedItem); });
        this.autocompleteConfigAPISource = new AutoCompleteConfig(this.repreList, this.minCharsForSearch, this.placeholder, this.responseApiKey, this.responseApiText, 'mail');
        this.hideErrorMsg();
        this._comService.findTiposDocumentos().subscribe(function (response) {
            _this.tdocList = response;
        });
        this._pflService.findPerfiles(0, 50).subscribe(function (response) {
            _this.perfiles = response.data;
        });
        this._comService.findRepresentantes().subscribe(function (response) {
            _this.repreList = response;
            //console.log(this.repreList);
            _this.autocomplete.setDataSource(_this.repreList);
        });
    };
    UsuarioPopupComponent.prototype.onChangeSelectRep = function (selected) {
        this.repre = this.repreList.find(function (item) { return item.codigo == selected.codigo; });
        //console.log(this.repre);
        // this.causa.concepto = this.concep;
        // this.causa.concepto.desc = this.causa.concepto.desc;
        //this.validateData();
    };
    UsuarioPopupComponent.prototype.loadUsr = function (id) {
        var _this = this;
        this.esModoAlta = false;
        this.titulo = "EDICIÓN DE USUARIO";
        this.subtitulo = "Modifique los datos para editar el usuario";
        this._usrService.findUsuario(id).subscribe(function (response) {
            _this.usuario = response;
            _this.visible = true;
            _this.autocomplete.select(_this.usuario.representante);
        });
    };
    UsuarioPopupComponent.prototype.newUsr = function () {
        this.esModoAlta = true;
        this.usuario = { id: 0, codigo: "", nombre: "", apellido: "", documento: "", tipoDoc: "", perfil: "", pfl_id: 0, mail: "", activo: true, categoria: true, activoStr: "", representante: null, matricula: "", localidad: "", direccion: "", codRep: "", permisos: [], configuraciones: [] };
        this.usuario.tipoDoc = this.tdocList[0].codigo;
        this.autocomplete.clear();
        this.titulo = "NUEVO USUARIO";
        this.subtitulo = "Complete los datos para dar de alta al nuevo Usuario";
        this.visible = true;
    };
    UsuarioPopupComponent.prototype.finalize = function () {
        this.visible = false;
        this.usuario = null;
        this.repre = null;
        this.esModoAlta = true;
        this.hideErrorMsg();
    };
    UsuarioPopupComponent.prototype.onClickSave = function () {
        var _this = this;
        this.usuario.usr_aud = KeycloakService.getLoggedUser();
        this.usuario.representante = this.repre;
        //console.log("-> USUARIO:  " + JSON.stringify(this.usuario));
        this.hideErrorMsg();
        if (this.validate()) {
            if (this.esModoAlta) {
                this._usrService.insert(JSON.stringify(this.usuario)).subscribe(function (response) {
                    _this.usuario = response;
                    //console.log("ID USUARIO GENERADO: " + this.usuario.id);
                    _this.onClose.emit(1);
                    _this.esModoAlta = false;
                    _this.showSuccessMessage("El Usuario se ingreso correctamente");
                    document.getElementById('_buttonCancel').click();
                }, function (error) {
                    var exc = ServiceException.parse(error.json());
                    //console.log(exc.toString());
                    _this.showErrorMessage(exc.description);
                });
            }
            else {
                this._usrService.update(JSON.stringify(this.usuario)).subscribe(function (response) {
                    _this.usuario = response;
                    _this.onClose.emit(1);
                    _this.showSuccessMessage("El Usuario se modifico correctamente");
                    document.getElementById('_buttonCancel').click();
                }, function (error) {
                    var exc = ServiceException.parse(error.json());
                    //console.log(exc.toString());
                    _this.showErrorMessage(exc.description);
                });
            }
        }
    };
    UsuarioPopupComponent.prototype.onClickCancelar = function () {
        this.onClose.emit(1);
    };
    UsuarioPopupComponent.prototype.onChangeSelectTipo = function (selected) {
        this.usuario.tipoDoc = selected;
    };
    UsuarioPopupComponent.prototype.onChangeSelectPfl = function (selected) {
        this.usuario.pfl_id = selected;
    };
    UsuarioPopupComponent.prototype.validate = function () {
        if (this.usuario.nombre == "") {
            this.showErrorMessage("El Nombre de Usuario no puede ser vacío");
            return false;
        }
        if (this.usuario.apellido == "") {
            this.showErrorMessage("El Apellido de Usuario no puede ser vacío");
            return false;
        }
        if (this.usuario.documento == "") {
            this.showErrorMessage("El Documento de Usuario no puede ser vacío");
            return false;
        }
        if (this.usuario.mail == "" || this.usuario.mail == null) {
            this.showErrorMessage("El Mail de Usuario no puede ser vacío");
            return false;
        }
        if (this.usuario.codigo == "") {
            this.showErrorMessage("El Código de Usuario no puede ser vacío");
            return false;
        }
        if (this.usuario.pfl_id == 0) {
            this.showErrorMessage("El Perfil de Usuario no puede ser vacío");
            return false;
        }
        // if (this.usuario.matricula == "" || this.usuario.matricula == null){
        //     this.showErrorMessage("La Matricula de Usuario no puede ser vacío");
        //     return false;
        // }
        return true;
    };
    UsuarioPopupComponent.prototype.showErrorMessage = function (msg) {
        this.ErrorMsg = msg;
        this.ErrorMessageIsVisible = true;
    };
    UsuarioPopupComponent.prototype.showSuccessMessage = function (msg) {
        this.SuccessMsg = msg;
        this.SuccessMessageIsVisible = true;
    };
    UsuarioPopupComponent.prototype.hideErrorMsg = function () {
        this.ErrorMsg = "";
        this.ErrorMessageIsVisible = false;
        this.hideSuccessMsg();
    };
    UsuarioPopupComponent.prototype.hideSuccessMsg = function () {
        this.SuccessMsg = "";
        this.SuccessMessageIsVisible = false;
    };
    return UsuarioPopupComponent;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], UsuarioPopupComponent.prototype, "onClose", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UsuarioPopupComponent.prototype, "id", void 0);
__decorate([
    ViewChild(AutocompleteComponent),
    __metadata("design:type", AutocompleteComponent)
], UsuarioPopupComponent.prototype, "autocomplete", void 0);
UsuarioPopupComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'usuario-popup',
        templateUrl: 'usuario-popup.component.html'
    }),
    __metadata("design:paramtypes", [UsuarioService,
        FormBuilder,
        PerfilService,
        CommonService])
], UsuarioPopupComponent);
export { UsuarioPopupComponent };
//# sourceMappingURL=usuario-popup.component.js.map